// @ts-nocheck
/** Build dialer country-code options from agentCountryCodeDirections (login / Storage). */
export function parseAgentCountryDirectionOptions(agentCountryCodeDirections) {
  if (!Array.isArray(agentCountryCodeDirections)) return [];

  const seen = new Set();
  const options = [];

  agentCountryCodeDirections.forEach((row) => {
    if (!row || row.is_deleted === true) return;
    const master = row.directionMaster;
    if (!master || master.is_deleted === true) return;

    const cc = master.country_code;
    const calling = String(cc?.calling_code ?? "")
      .trim()
      .replace(/^\+/, "");
    if (!calling) return;

    const id = String(row.country_code_direction_id ?? master.id ?? row.id);
    if (seen.has(id)) return;
    seen.add(id);

    options.push({
      id,
      callingCode: calling,
      display: `+${calling}`,
    });
  });

  return options;
}

function getCountryFromDirection(item) {
  if (!item) return {};
  return item.country_code || item.directionMaster?.country_code || {};
}

export function isIndiaCountry(country) {
  if (!country) return false;
  const name = String(country.name || "").toLowerCase();
  const code = String(country.code || "").toUpperCase();
  const calling = String(country.calling_code || "").replace(/^\+/, "");
  return name.includes("india") || code === "IN" || calling === "91";
}

export function getIndiaCallingCodeFromCountry(country) {
  if (!isIndiaCountry(country)) return "";
  return String(country?.calling_code || "91").replace(/^\+/, "");
}

export function getIndiaCallingCodeFromDirections(directions) {
  const match = (Array.isArray(directions) ? directions : []).find((d) =>
    isIndiaCountry(getCountryFromDirection(d)),
  );
  if (!match) return "";
  return String(getCountryFromDirection(match).calling_code || "91").replace(/^\+/, "");
}

export function getIndiaDirectionIds(directions) {
  return (Array.isArray(directions) ? directions : [])
    .filter((d) => isIndiaCountry(getCountryFromDirection(d)))
    .map((d) => d.id ?? d.directionMaster?.id)
    .filter((id) => id != null);
}

export function formatAgentUniqueConflictMessage(msg) {
  const s = String(msg || "");
  if (s.includes("Agent Name Already Exists")) {
    return "Agent name must be unique within this call centre. This name is already in use.";
  }
  if (s.includes("Agent Number Already Exists")) {
    return "Agent number must be unique within this call centre. This number is already in use.";
  }
  return s;
}
